import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationATM from "../../../../../Common/ConfirmationATM";
import CommonDataTableFilterHeader from "../../../../../Common/DataTableHeader/CommonDataTableFilterHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import DataTable from "../../../../../Common/DataTable/DataTable";
import { TableColumns } from "./TableColumn";
import {
  DELETE_TABLE_LIST_REQUEST,
  GET_TABLE_LIST_REQUEST,
  PUT_TABLE_LIST_REQUEST,
  RESET_TABLE_FLAGS,
} from "../../../../../Utils/Constant";
import TableList from "../TableList";
import { format } from "date-fns";
import { hasDeleteAccess, hasEditAccess } from "../../../../../Common/CheckAccess";

const TablesTable = ({ shouldRefresh, setShouldRefresh, setSelectedTable, selectedTable, sidebarRef, isLoading }) => {
  const dispatch = useDispatch();
  const FilterOptions = ["Select", "Room Type", "Amenities", "Price", "Capacity"];

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [startDate, setStartDate] = useState(null);

  const { tablesList = []} = useSelector((state) => state.table);
  const handleView = (table) => {
    setSelectedTable(table);
    
    sidebarRef.current?.openSidebar();
  };

const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const handleOpenDelete = (table) => {
    setSelectedTable(table);
    setShowDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedTable?.id) {
      dispatch({ type: DELETE_TABLE_LIST_REQUEST, payload: {id:selectedTable.id }});
    }
    setShowDeleteDialog(false);
    setShouldRefresh((prev)=>!prev)
    setSelectedTable(null);
  };

 
  // Fetch table list
  useEffect(() => {
    const payload = { page: currentPage, limit: pageSize };
    if(startDate){
      payload.datetime=startDate
    }
    dispatch({ type: GET_TABLE_LIST_REQUEST, payload });
  }, [dispatch, currentPage, pageSize, shouldRefresh,startDate, dispatch]);

  // Transform and set data
  useEffect(() => {
    const tableData = tablesList?.data?.data || [];
    const pagination = tablesList?.data?.pagination;

    const transformed = tableData.map((table, index) => ({
      id: (currentPage - 1) * pageSize + index + 1,
      name: table.name || "-",
      location: table.location || "-",
      capacity: table.capacity || "-",
      status: table.status || "-",
      actions: (
        <>
         {hasDeleteAccess(permissions, "restaurant") && <button className="btn" onClick={() => handleOpenDelete(table)}>
            <i className="bi bi-trash text-danger"></i>
          </button>}
          <button className="btn" onClick={() => handleView(table)} disabled={!hasEditAccess(permissions, "restaurant")}
            >
            <i className="bi bi-eye text-primary"></i>
          </button>
        </>
      ),
    }));

    setData(transformed);
    setTotalEntries(pagination?.totalResults || transformed.length);
  }, [tablesList, currentPage, pageSize]);

  const totalPages = Math.ceil(totalEntries / pageSize);


  const toDateTimeLocal = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const offset = date.getTimezoneOffset();
    const local = new Date(date.getTime() - offset * 60000); // Convert UTC to local time
    return local.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  };

  return (
    <>
      {/* <CommonDataTableFilterHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        setCurrentPage={setCurrentPage}
        FilterOptions={FilterOptions}
      /> */}
      <div className="col-12 d-flex flex-wrap justify-content-end align-items-center gap-3 mb-2">
        <div className="">
          <label className="form-label mb-0">Select Date:</label>
          <input
            type="datetime-local"
            className="form-control"
            value={startDate}
            onChange={(e) =>
              setStartDate(e.target.value)
            }
          />
        </div>
      </div>

      <DataTable
        columns={TableColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={isLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />

      <ConfirmationATM
        show={showDeleteDialog}
        onClose={() => {
          setShowDeleteDialog(false);
          setSelectedTable(null);
        }}
        onConfirm={handleConfirmDelete}
        message={`Are you sure you want to delete the "${selectedTable?.name}" Table?`}
      />
    </>
  );
};

export default TablesTable;
